export type ViewMode = 'folder' | 'list';

export type DocumentTypeFilter = 'all' | 'file' | 'url';
// CR-5327: Filter mirrors the visibility values offered in the upload
// form (private / shared / public) so users can locate Shared docs from
// the page filter, which previously only exposed All / Public / Private.
export type VisibilityFilter = 'all' | 'public' | 'private' | 'shared';

export interface DocumentFilters {
  documentType: DocumentTypeFilter;
  category: string;
  visibility: VisibilityFilter;
}

export const INITIAL_FILTERS: DocumentFilters = {
  documentType: 'all',
  category: 'all',
  visibility: 'all',
};

// Three visibility modes map onto backend fields so the UI stays simple
// while the underlying scoping is explicit:
//   private: only the owning company sees it (default)
//   shared:  the owning company + an explicit allow-list of supplier
//            companies via Document.shared_with_companies
//   public:  every authenticated user (sets is_public=true)
export type DocumentVisibility = 'private' | 'shared' | 'public';

export interface UploadFormData {
  title: string;
  description: string;
  category: string;
  document_type: 'file' | 'url';
  file: File | null;
  external_url: string;
  visibility: DocumentVisibility;
  shared_with_company_ids: number[];
  tags: string;
  version: string;
  // CR-5329: when true, recipients must Read & Accept. Notification
  // fan-out fires only for shared visibility — see backend
  // notify_acceptance_required().
  requires_acceptance: boolean;
}

export const INITIAL_UPLOAD_FORM: UploadFormData = {
  title: '',
  description: '',
  category: '',
  document_type: 'file',
  file: null,
  external_url: '',
  visibility: 'private',
  shared_with_company_ids: [],
  tags: '',
  version: '',
  requires_acceptance: false,
};
